import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';

import api from 'services';

class ArchiveLetter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowSelectionPopup: false,
        };

        this.toggleSelectionPopup = this.toggleSelectionPopup.bind(this);
        this.sendLetterToArchive = this.sendLetterToArchive.bind(this);
    }

    toggleSelectionPopup() {
        this.setState({
            isShowSelectionPopup: !this.state.isShowSelectionPopup,
        });
    }

    sendLetterToArchive() {
        api.sendLetterToArchive(this.props.letter._id)
            .then((response) => {
                if (response.status) {
                    this.props.router.push('/');
                }
            });
    }

    render() {
        const actions = [
            <FlatButton
                label='Cancel'
                primary
                onClick={this.toggleSelectionPopup}
            />,
            <FlatButton
                label='Send'
                secondary
                onClick={this.sendLetterToArchive}
            />,
        ];

        return (
            <div className='btn'>
                <RaisedButton
                    labelStyle={{ fontSize: '10px', margin: '-10px' }}
                    style={{ height: '25px' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                    label='Send to archive'
                    onClick={this.toggleSelectionPopup}
                    secondary
                />
                <Dialog
                    title='Send letter to archive?'
                    actions={actions}
                    open={this.state.isShowSelectionPopup}
                    onRequestClose={this.toggleSelectionPopup}
                >
                    This letter will be send to archive.
                </Dialog>
            </div>
        );
    }
}

export default connect(
    (state, ownProps) => {
        return {
            router: ownProps.router,
            letter: state.letter,
        };
    },
    dispatch => bindActionCreators({
    }, dispatch),
)(ArchiveLetter);



// WEBPACK FOOTER //
// ./app/components/Letters/Single/ArchiveLetter.jsx